import React from 'react';
import PropTypes from 'prop-types';
import {IconComponent} from 'components/common/IconComponent'
import {Link} from "react-router-dom";

function Btn(props) {
  const { children, className, withArrow, disabled, onClick, href, to, icon, type } = props;
  const mainClass = `btn-loyalty ${className || ''} ${withArrow ? 'flex items-center justify-between' : ''}`;
  //IS A LINK REACT
  if (to) {
    return (
            <Link to={to} className={mainClass}>
              <span>{children}</span>
              {withArrow && <IconComponent icon="arrow" className="ml-2"/>}
            </Link>
    )
  }
  //IS A LINK
  if (href) {
    return (
            <a href={href} className={mainClass} target="_blank" rel="noopener noreferrer">
              <span>{children}</span>
              {withArrow && <IconComponent icon="arrow" className="ml-2"/>}
            </a>
    )
  }
  //IS AN ACTION (default btn) — type="button" avoids submitting parent forms
  return (
          <button type={type || 'button'} onClick={onClick} disabled={disabled} className={mainClass}>
            {icon && <IconComponent icon={icon} className="mr-2"/>}
            <span>{children}</span>
            {withArrow && <IconComponent icon="arrow" className="ml-2"/>}
          </button>
  );
}

Btn.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  withArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  type: PropTypes.string,
}

Btn.defaultProps = {
  className: '',
  withArrow: false,
  onClick: () => {
  },
  disabled: false,
  type: 'button',
};

export default Btn;


